import { HeaderType } from '../../webhooks.types';

import { AuthorizationItem } from './authorizationHeader.types';

export const headerKey = 'Authorization';

export const encodeHeader = (
  value: string,
  type?: HeaderType | null,
): Record<string, string> =>
  type && value.trim().replace(':', '')
    ? {
        [headerKey]:
          type === 'basic' ? `Basic ${window.btoa(value)}` : `Bearer ${value}`,
      }
    : {};

export const getHeaderType = (
  header: Record<string, string>,
): HeaderType | null => {
  const value = header[headerKey];

  if (!value?.startsWith('Basic ') && !value?.startsWith('Bearer ')) {
    return null;
  }

  const [format] = value.split(' ');

  return format === 'Bearer' ? 'token' : 'basic';
};

export const authorizationItems: AuthorizationItem[] = [
  { id: 'basic', name: 'Basic Auth' },
  { id: 'token', name: 'Token' },
];
